/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as Scatter3DLayerSpec } from '../../../../layer/preset/scatter/scatter3D';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';
import type { Data } from '../../specProcessor';

export type Spec = BaseSpec;

type Scatter3DLayerType = StandardChartLayerSpec & Scatter3DLayerSpec & ILayerTypeSpec;

// 创建3D散点图数据类型验证器
const validateScatter3DDataTypes = createDataTypeValidator('scatter3D', [
  { field: 'x', type: 'string' },
  { field: 'y', type: ['string', 'date'] },
  { field: 'z', type: 'number' },
  { field: 'size', type: 'number', required: false },
  { field: 'color', type: 'number', required: false }
]);

// 创建3D散点图编码验证器
const validateScatter3DEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y' },
  { field: 'z' },
  { field: 'size', required: false },
  { field: 'color', required: false }
]);

// 额外的检查函数
const additionalScatter3DChecks = (layer: Scatter3DLayerType, data: Data) => {
  // 检查数据量是否足够
  const dataIndex = layer.dataIndex || 0;
  const values = data[dataIndex]?.values || [];
  if (values.length <= 1) {
    utils.logger.warn(
      'warning',
      `"${layer.type}" layer requires more than 1 data point to be effective`
    );
  }
};

// 创建并导出3D散点图处理器
export const scatter3D = createLayerProcessor<Scatter3DLayerType>(
  'scatter3D',
  validateScatter3DEncoding,
  validateScatter3DDataTypes,
  additionalScatter3DChecks
);
